export enum MARKETPLACE {
  ENOVA = '937a3daf-c9ee-4a23-8dec-18759a399b3d',
  NOVASTORE = '634b0885-cbb4-4877-a04d-72d9b3ff680a',
  DETECNOLOGIA = 'de7b59ec-8fed-416b-9083-dc3cb5f7a4c7',
  PIPESTORE = '32d4e45d-a011-4185-8ba6-a58e99c54ac2',
}